import { Button, Header } from "@datagame/ui";
import { useMediaQuery } from "react-responsive";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import { RatingScale } from "../../../shared/RatingScale";
import { useWordopolis } from "../../../../hooks/useWordopolis";
import { WordopolisActionKind } from "../../../../reducers/wordopolis";
import { WordopolisModal } from "../WordopolisModal";

import styles from "./RatingScaleModal.module.scss";

const cx = classNames.bind(styles);

export const RatingScaleModal = () => {
  const [
    {
      configuration: {
        attributes,
        ratingQuestion,
        ratingLeftLabel,
        ratingRightLabel,
        ratingScaleSize,
        gameVisuals: { themeColor },
      },
      status: { toRate, isGameFinished },
    },
    dispatch,
  ] = useWordopolis();
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });
  const { t } = useTranslation();

  const initialRating = Math.ceil(ratingScaleSize / 2);
  const [currentWord] = toRate;
  const currentAttribute = attributes.find(({ name }) => name === currentWord);
  const [rating, setRating] = useState(initialRating);

  const handleRate = () => {
    dispatch({ type: WordopolisActionKind.RATE_WORD, payload: { ratingScore: rating } });
  };

  useEffect(() => {
    setRating(initialRating);
  }, [toRate.length]);

  const { question, leftLabel, rightLabel, scaleSize } = useMemo(() => {
    let result = {
      question: ratingQuestion,
      leftLabel: ratingLeftLabel,
      rightLabel: ratingRightLabel,
      scaleSize: ratingScaleSize,
    };

    if (currentAttribute?.customRatingQuestion) {
      result = {
        ...currentAttribute.customRatingQuestion,
      };
    }

    return result;
  }, [currentAttribute, ratingQuestion, ratingLeftLabel, ratingRightLabel, ratingScaleSize]);

  return (
    <WordopolisModal
      isVisible={Boolean(toRate.length)}
      className={styles.modal}
      portalClassName={cx({ delayed: isGameFinished })}
    >
      <div className={styles.wordModal}>
        <Header className={styles.header} variant="h5">
          {question}
        </Header>
        <div className={styles.word}>
          {currentWord?.split("").map((letter, index) => (
            <span key={index} className={styles.letter}>
              {letter}
            </span>
          ))}
        </div>
      </div>
      <div className={styles.ratingModal}>
        <div className={styles.ratingModalContent}>
          <Header variant="h6" className={styles.ratingLabels}>
            <span className={styles.ratingLeft}>{leftLabel}</span>
            <span className={styles.ratingRight}>{rightLabel}</span>
          </Header>
          <RatingScale className={styles.scale} min={1} max={scaleSize} value={rating} onChange={setRating} />
          <Button
            customColor={themeColor}
            size={isDesktop ? "large" : "medium"}
            className={styles.rateButton}
            kind="outline"
            onClick={handleRate}
          >
            {t("continue")}
          </Button>
        </div>
      </div>
    </WordopolisModal>
  );
};
